export default __webpack_public_path__ + "static/media/portrait.fcd1f81b.svg";